export function formattedItem(itemList) {
  return itemList?.map((item) => ({
    id: item.Id,
    Name: item.Name || '',
    itemStatus: 'Enabled',
    Description: item.Description || '',
    FullyQualifiedName: item.FullyQualifiedName || '',
    Sku: item.Sku || '',

    Active: item.Active !== false,
    Taxable: item.Taxable || false,
    UnitPrice: item.UnitPrice || 0,
    Type: item.Type || '',

    SalesTaxIncluded: item.SalesTaxIncluded || false,
    PurchaseDesc: item.PurchaseDesc || '',
    PurchaseTaxIncluded: item.PurchaseTaxIncluded || false,
    PurchaseCost: item.PurchaseCost || 0,

    IncomeAccountRef: item.IncomeAccountRef || '',
    ExpenseAccountRef: item.ExpenseAccountRef || '',

    PurchaseTaxCodeRef: item.PurchaseTaxCodeRef || '',
    SalesTaxCodeRef: item.SalesTaxCodeRef || '',
    ClassRef: item.ClassRef || '',
    ParentRef: item.ParentRef || '',
    PrefVendorRef: item.PrefVendorRef || '',
    SubItem: item.SubItem || false,

    AssetAccountRef: item.AssetAccountRef || '',
    InvStartDate: item.InvStartDate || '',

    TrackQtyOnHand: item.TrackQtyOnHand || false,
    QtyOnHand: item.QtyOnHand ?? 0,
    ReorderPoint: item.ReorderPoint ?? 0,
    domain: item.domain || '',
    Id: item.Id,
    sparse: item.sparse || false,
    SyncToken: item.SyncToken || ''
  }));
}

// eslint-disable-next-line no-undef
const NUMERIC_ITEM_FIELDS = new Set(['UnitPrice', 'PurchaseCost', 'QtyOnHand', 'ReorderPoint']);

const normalizeItemValue = (field, value) => {
  if (NUMERIC_ITEM_FIELDS.has(field)) return value === '' ? 0 : Number(value);
  return value;
};

const comparableValue = (value) => {
  if (!value || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(comparableValue);
  return Object.keys(value)
    .sort()
    .reduce((result, key) => ({ ...result, [key]: comparableValue(value[key]) }), {});
};

export function meaningfulItemChanges(row, changes) {
  return Object.entries(changes || {}).reduce((result, [field, value]) => {
    const normalizedValue = normalizeItemValue(field, value);
    const currentValue = normalizeItemValue(field, row[field]);
    if (JSON.stringify(comparableValue(normalizedValue)) === JSON.stringify(comparableValue(currentValue))) {
      return result;
    }
    return { ...result, [field]: normalizedValue };
  }, {});
}

export function sparseItemUpdate(row, changes) {
  const changedFields = Object.entries(changes || {}).reduce((result, [field, value]) => {
    return { ...result, [field]: normalizeItemValue(field, value) };
  }, {});

  return {
    Id: row.Id || row.id,
    SyncToken: row.SyncToken,
    sparse: true,
    ...changedFields
  };
}
